<template>
    <div class="imgContainer">
        <div class="imgWrapper" v-for="(file, i) in files" :key="'file_'+i">
            <div class="img">
                <img :id="'img_'+i" :src="createImage(file, i)"/>
            </div>
            <div class="filenameContainer">
                <span class="filename"></span>
            </div>
            <RoundedIconButton icon-color="#d70364" size="small" icon="delete"
                               @click="$emit('delete', file)" title="Löschen"></RoundedIconButton>
        </div>
    </div>
</template>

<script>
    import RoundedIconButton from "../../components/buttons/RoundedIconButton";

    export default {
        name: "DashboardImagePreview",
        components: {RoundedIconButton},
        props: {
            files: {
                required: true
            }
        },
        methods: {
            createImage(file, i) {
                let reader = new FileReader();
                if (file.type.indexOf('image') !== -1) {
                    reader.onload = (event) => {
                        document.getElementById('img_' + i).src = event.target.result;
                        document.getElementById('img_' + i).title = file.name;
                        let filenameSpan = document.getElementById('img_' + i).parentElement.parentElement.querySelector('.filename');
                        filenameSpan.innerHTML = file.name;
                        filenameSpan.title = file.name;
                    };
                    reader.readAsDataURL(file);
                } else {
                    reader.onload = function () {
                        var blob = new Blob([reader.result], {type: file.type});
                        var url = URL.createObjectURL(blob);
                        var video = document.createElement('video');
                        var timeupdate = function () {
                            if (snapImage()) {
                                video.removeEventListener('timeupdate', timeupdate);
                                video.pause();
                            }
                        };
                        video.addEventListener('loadeddata', function () {
                            if (snapImage()) {
                                video.removeEventListener('timeupdate', timeupdate);
                            }
                        });
                        var snapImage = function () {
                            var canvas = document.createElement('canvas');
                            canvas.width = video.videoWidth;
                            canvas.height = video.videoHeight;
                            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                            var image = canvas.toDataURL();
                            var success = image.length > 100000;
                            if (success) {
                                var img = document.getElementById('img_' + i);
                                img.src = image;
                                let filenameSpan = img.parentElement.parentElement.querySelector('.filename');
                                filenameSpan.innerHTML = file.name;
                                filenameSpan.title = file.name;
                                img.title = file.name;
                                URL.revokeObjectURL(url);
                            }
                            return success;
                        };
                        video.addEventListener('timeupdate', timeupdate);
                        video.preload = 'metadata';
                        video.src = url;
                        // Load video in Safari / IE11
                        video.muted = true;
                        video.playsInline = true;
                        video.play();
                    };
                    reader.readAsArrayBuffer(file);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .imgContainer {
        display: flex;
        flex-flow: wrap;
        width: 100%;
        margin-top: 10px;
    }

    .imgWrapper {
        position: relative;
        width: 160px;
        height: 120px;
        background: #fff;
        margin-left: 10px;
        margin-top: 10px;
        padding: 6px;

        .img {
            width: 100%;
            height:89%;
            overflow: hidden;
            margin-bottom: 4px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }


        .filenameContainer {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: relative;
            top: -5px;

            .filename{
                font-size: 12px;
            }
        }

        ::v-deep .rounded-icon-button-wrapper {
            width: 36px !important;
            height: 36px !important;
            position: absolute;
            top: 30%;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            text-align: center;

            .icon {
                margin-top: 5px;
                font-size: 18px !important;
                margin-left: -2px;
            }
        }

        &:hover ::v-deep .rounded-icon-button-wrapper:hover {
            opacity: 1;
            z-index: 10;
        }
    }
    @media screen and (min-width: 1200px) {
        .imgWrapper {
            &:hover ::v-deep .rounded-icon-button-wrapper {
                opacity: .6;
                z-index: 10;
            }
        }
    }
    @media screen and (max-width: 1200px) {
        .imgWrapper {
            ::v-deep .rounded-icon-button-wrapper {
                opacity: .8;
                z-index: 10;
            }
        }
    }
</style>